import { FunctionComponent } from "react";
import AsyncSearchSelect from "../common/async_search_select/AsyncSearchSelect";
import { fetchGet, toQueryString } from "../../../service/api_client";

interface DcResult {
  id: string;
}

interface DcSelectFieldProps {
  /** Selected DC reference id. */
  value?: string;
  onSelect: (dc: DcResult) => void;
  disabled?: boolean;
  placeholder?: string;
}

const fetchDc = async (query: string): Promise<DcResult[]> => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/get-st-dc-search`;
  const res = await fetchGet(
    url + toQueryString({ search: query, page: 1, count: 20, all: true }),
  );
  return res.success && Array.isArray(res.data?.data) ? res.data.data : [];
};

/** Stock-transfer DC async search (Job Work). Value is the DC reference id. */
const DcSelectField: FunctionComponent<DcSelectFieldProps> = ({
  value,
  onSelect,
  disabled,
  placeholder,
}) => (
  <AsyncSearchSelect<DcResult>
    value={value ? { id: value } : null}
    onSelect={onSelect}
    disabled={disabled}
    size="md"
    placeholder={placeholder ?? "Search DC"}
    fetcher={fetchDc}
    getOptionLabel={(d) => d?.id ?? ""}
    getOptionKey={(d) => d?.id ?? ""}
    renderOption={(d) => (
      <div className="text-xs">
        <b>{d.id}</b>
      </div>
    )}
  />
);

export default DcSelectField;
